import { api } from "./api";

const SESSION_KEY = "cdp_session_id";
const ALLOWED = new Set(["mesa", "pantalla", "cartel", "otros"]);

export const resolveQrZone = (raw) => {
  if (!raw) return null;
  return ALLOWED.has(raw) ? raw : "otros";
};

const createSessionId = () => {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return `session-${Date.now()}-${Math.random().toString(36).slice(2)}`;
};

export const getSessionId = () => {
  try {
    const existing = sessionStorage.getItem(SESSION_KEY);
    if (existing) return existing;
    const next = createSessionId();
    sessionStorage.setItem(SESSION_KEY, next);
    return next;
  } catch {
    return createSessionId();
  }
};

export const trackPageview = (path, zone = null) => {
  return api.post("/track", { zone, path, session_id: getSessionId() });
};
